import { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import PostLoginLayout from '../PostLoginLayout';
import PreLoginLayout from '../PreLoginLayout';
import { resolveRouteLayout, isPublicGalleryRoute } from '../resolveRouteLayout';
import layoutStyles from './Layout.module.css';

import { useUiStore } from '../../store/useUiStore';
import useAuth from '../../../shared/hooks/useAuth';
import type { CommonType } from '../../../shared/types/CommonType';

const Style = {
  width: '100%', 
  height: '100vh',
  color: 'var(--color-text-secondary)',
  display: 'flex',
  alignItems: 'center', 
  justifyContent: 'center'
}

const Layout = ({ children }: CommonType) => {
  const { pathname } = useLocation();
  const storeLayoutType = useUiStore((state) => state.layout.type);
  const routeLayout = resolveRouteLayout(pathname);
  const layoutType = routeLayout ?? storeLayoutType;
  const { authenticated } = useAuth();
  const isPublicGallery = isPublicGalleryRoute(pathname);

  return (
    <Suspense
      fallback={<div style={Style}>Loading...</div>}
    >
      {authenticated ? (
        isPublicGallery ? (
          <PostLoginLayout layoutType={layoutType}>
            {children}
          </PostLoginLayout>
        ) : (
          <div className={layoutStyles.authenticatedShell}>
            <PostLoginLayout layoutType={layoutType}>
              {children}
            </PostLoginLayout>
          </div>
        )
      ) : (
        <PreLoginLayout>{children}</PreLoginLayout>
      )}
    </Suspense>
  );
};

export default Layout;
